import { createStandaloneToast } from '@chakra-ui/react';

const { ToastContainer, toast: standaloneToast } = createStandaloneToast();
export { standaloneToast, ToastContainer };
